
import React from 'react';
import { Users, Book, Globe } from 'lucide-react';

const AboutApproach = () => {
  return (
    <section className="py-16 bg-gray-50">
      <div className="container mx-auto px-4">
        <div className="text-center mb-12">
          <h2 className="text-3xl font-serif font-bold mb-4">Min undervisningstilgang</h2>
          <p className="text-lg text-gray-600 max-w-3xl mx-auto">
            En personlig og professionel klaverundervisning der er skræddersyet til dine behov og mål.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 max-w-5xl mx-auto">
          <ApproachCard 
            icon={<Users className="h-7 w-7" />}
            title="Personlig tilgang"
            description="Hver elev er unik med individuelle behov, styrker og udfordringer. Min undervisning tilpasses dig, dit niveau og dine personlige mål med klaveret."
          />

          <ApproachCard 
            icon={<Book className="h-7 w-7" />}
            title="Solid teori & teknik"
            description="God teknik danner grundlaget for alt klaverspil. Jeg lægger vægt på at udvikle en solid teknisk basis samtidig med at teori integreres naturligt i undervisningen."
          />

          <ApproachCard 
            icon={<Globe className="h-7 w-7" />}
            title="Bredt repertoire"
            description="Fra jazz og pop til klassiske værker - jeg hjælper dig med at udforske forskellige genrer og finde din egen musikalske stemme gennem klaveret."
          />
        </div>
      </div>
    </section>
  );
};

interface ApproachCardProps {
  icon: React.ReactNode;
  title: string;
  description: string;
}

const ApproachCard = ({ icon, title, description }: ApproachCardProps) => {
  return (
    <div className="bg-white p-8 rounded-lg shadow-md">
      <div className="inline-flex items-center justify-center w-14 h-14 rounded-full bg-piano-gold/10 text-piano-gold mb-6">
        {icon}
      </div>
      <h3 className="text-xl font-serif font-semibold mb-4">{title}</h3>
      <p className="text-gray-600">
        {description}
      </p>
    </div>
  );
};

export default React.memo(AboutApproach);
